import * as React from "react";

function GamingSvg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={40.164}
      height={26.604}
      {...props}
    >
      <path
        d="M36.572 4.705c-5.3-8.716-13.3-2.652-13.3-2.652a4.142 4.142 0 01-2.123.715h-2.137a4.114 4.114 0 01-2.123-.713S8.9-4.008 3.592 4.707A26.892 26.892 0 00.425 22.908c.374 2.323 1.609 3.874 3.938 3.679s7.364-6.257 7.364-6.257a2.873 2.873 0 011.937-.908h12.833a2.868 2.868 0 011.936.908s5.042 6.063 7.368 6.257 3.564-1.357 3.936-3.679a26.884 26.884 0 00-3.165-18.203zm-21.313 7.094h-2.752v2.649a2.565 2.565 0 01-1.484.434 1.793 1.793 0 01-1.308-.485v-2.6h-2.6a2.09 2.09 0 01-.411-1.208 2.772 2.772 0 01.359-1.583h2.753V6.257a2.991 2.991 0 011.38-.28 3.639 3.639 0 011.412.332l-.011 2.7h2.6a2.588 2.588 0 01.491 1.287 3.25 3.25 0 01-.429 1.503zm12.621 3.023a2.178 2.178 0 112.179-2.174 2.175 2.175 0 01-2.178 2.174zm0-5.992a2.178 2.178 0 112.179-2.182 2.174 2.174 0 01-2.178 2.182zm5.42 3.218a2.178 2.178 0 112.179-2.178 2.174 2.174 0 01-2.179 2.178z"
        fill="#ff7b16"
      />
    </svg>
  );
}

export default GamingSvg;
